<div class="text title-section">Useful information to provide when contacting support :</div>

<div class="mt-3">
    <div>
        <span class="text-body-bold">Project</span> : <span class="selectable-info">{{ (project$ | async)?.name }}</span> (<span
            class="selectable-info"
            >{{ (project$ | async)?.projectId }}</span
        >)
    </div>
    <div>
        <span class="text-body-bold">Node</span> : <span class="selectable-info">{{ (classificationNode$ | async)?.name }}</span> -
        {{ (classificationNode$ | async)?.classificationNodeType }} (<span class="selectable-info">{{
            (classificationNode$ | async)?.classificationNodeId
        }}</span
        >)
    </div>
    <div>
        <span class="text-body-bold">User</span> : <span class="selectable-info">{{ (user$ | async)?.email }}</span> (<span
            class="selectable-info"
            >{{ (user$ | async)?.id }}</span
        >)
    </div>
    <div>
        <span class="text-body-bold">Dashboard</span> : <span class="selectable-info">{{ dashboard$ | async }}</span> (<span
            class="selectable-info"
            >{{ dashboardId$ | async }}</span
        >)
    </div>
    <div>
        <span class="text-body-bold">Period</span> : <span class="selectable-info">{{ period$ | async }}</span>
    </div>
    <div>
        <span class="text-body-bold">Current URL</span> : <span class="selectable-info">{{ currentUrl }}</span>
    </div>
    <div>
        <span class="text-body-bold">User agent</span> : <span class="selectable-info">{{ userAgent }}</span>
    </div>
    <div>
        <span class="text-body-bold">Memory Info</span> : <span class="selectable-info">{{ memoryInfo }}</span>
    </div>
    <div>
        <span class="text-body-bold">Version</span> : <span class="selectable-info">{{ version }}</span>
    </div>
    <div>
        <span class="text-body-bold">Team in charge</span> : <span class="selectable-info">{{ routeTeam() }}</span>
    </div>
</div>

<p class="text">You can display this information at any time using the shortcut Ctrl + Alt + E or Ctrl + Alt + I</p>
